import { render, staticRenderFns } from "./Locator.vue?vue&type=template&id=39547b8e&scoped=true&"
import script from "./Locator.vue?vue&type=script&lang=ts&"
export * from "./Locator.vue?vue&type=script&lang=ts&"
import style0 from "./Locator.vue?vue&type=style&index=0&id=39547b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39547b8e",
  null
  
)

export default component.exports